'use client';

import { useEffect, useRef } from 'react';
import { realtime } from '@/lib/websocket';

type RealtimeCallback<T = any> = (payload: T) => void;

export function useRealtime<T = any>(
  event: string,
  callback: RealtimeCallback<T>,
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handler = (payload: T) => {
      callbackRef.current(payload);
    };

    realtime.on(event, handler);

    return () => {
      realtime.off(event, handler);
    };
  }, [event]);
}